import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { isValidUpdateApplicationMarket } from '../../utils/isValidUpdateApplicationMarket/isValidUpdateApplicationMarket.utils';
import { logToSentry } from '~/helpers/loggers.helper';

export const useShouldRenderUpdateApplication = () => {
  const [shouldRender, setShouldRender] = useState(true);

  const {
    intl: { market },
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    const validPreOfferMarket = isValidUpdateApplicationMarket(market);
    if (!validPreOfferMarket) {
      logToSentry(
        new Error(`Unsupported market for pre-offer`),
        `Unsupported pre-offer market ${market}`
      );
    }
    setShouldRender(validPreOfferMarket);
  }, [market]);

  return shouldRender;
};
